export default function SuccessButton({ handleClick }) {
  return (
    <button
      id="successBtn"
      className="flex justify-center bg-nimbusDark font-bold p-2 text-white cursor-pointer rounded"
      onClick={handleClick}
    >
      <p>Verificar dirección</p>
    </button>
  );
}
